import { BodyContainer } from '../../../../elements';
import { useSmallScreenAndBelowMediaQuery } from '../../../../layouts/ResponsiveMedia';
import { DesktopWaveDetailScreen } from './desktop-detail';
import { MobileWaveDetailScreen } from './mobile-detail';

/**
 * The mobile layout is the only place the web app can pick and sort a wave.
 * The desktop layout is allocation management only and its table collapses
 * below ~1100px, so the wave detail switches to the mobile pick UI at the
 * app's "small screen" cut (1024px) rather than the shared 768px MobileMode.
 */
export function WaveDetailScreen() {
  const isSmallScreenAndBelow = useSmallScreenAndBelowMediaQuery();

  return (
    <BodyContainer className="no-header">
      {isSmallScreenAndBelow ? <MobileWaveDetailScreen /> : <DesktopWaveDetailScreen />}
    </BodyContainer>
  );
}
